


























































































































































































































































































































































































































































import Vue, { PropType } from 'vue'
import gql from 'graphql-tag'
import dateFormat from 'dateformat'

export type Batch = {
  id?: string;
  name: string;
  description: string;
  batchLinks: BatchLink[];
  csv?: string;
  isTemplate?: boolean;
  queueLetter?: string;
  scheduleType?: 'weekly' | 'monthly' | 'custom' | null;
  scheduleDay?: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday' | number | null;
  scheduleTime?: number | null;
  scheduleCron?: string | null;
  scheduledRunningPaused?: boolean;
  useForLinkAssurance?: boolean;
  notifyOnComplete?: boolean;
}

export type BatchLink = {
  id?: string;
  batchId?: string;
  link?: string;
  order?: number;
  userDefinedNetwork?: string;
  userDefinedMerchant?: string;
  placement?: string;
  name?: string;
  tagA?: string;
  tagB?: string;
  tagC?: string;
  tagD?: string;
  tagE?: string;
  countryCode?: string;
  proxyYN?: boolean;
  proxyCountryCode?: string | null;
  cookieType?: string | null;
  cookieName?: string;
  cookieValue?: string;
  extraTimeout?: boolean;
  advancedOptionsVisible?: boolean;
  editing?: boolean;
}

type EditorTab = 'links' | 'schedule' | 'queue'

type Data = {
  defaultNewLink: BatchLink;
  batch: Batch;
  isBatchBroken: boolean;
  editingTitle: boolean;
  unsavedChanges: boolean;
  saving: boolean;
  showEditor: boolean;
  showMoreOptions: boolean;
  currentTab: EditorTab;
  runNowLink: null | string;
  newBatchOwnerId: null | string;
  editingOwner: boolean;
  availableScheduleTypes: string[];
}

export default Vue.extend({

  props: {
    batchId: {
      type: String,
      required: false,
    },
    preloadedBatch: {
      type: Object as PropType<Batch>,
      required: false,
    },
    queueCounts: {
      type: Array,
      required: false,
    },
  },

  data(): Data {
    return {
      defaultNewLink: {
        advancedOptionsVisible: false,
        countryCode: 'gb',
        cookieType: null,
        proxyCountryCode: null,
        editing: true,
      },
      batch: {
        name: '',
        description: '',
        batchLinks: [],
        isTemplate: true,
        scheduleType: null,
        scheduleDay: null,
        scheduleTime: null,
      },
      isBatchBroken: false,
      editingTitle: false,
      showEditor: false,
      unsavedChanges: false,
      saving: false,
      showMoreOptions: false,
      currentTab: 'links',
      runNowLink: null,
      newBatchOwnerId: null,
      editingOwner: false,
      availableScheduleTypes: ['weekly', 'custom'],
    }
  },

  computed: {
    filteredScheduleTypes() {
      const types = [...new Set(this.availableScheduleTypes)];
      if (this.$moonpull.currentUserHasAccessTo('monthlyScheduling')) {
        types.push('monthly');
      }
      if (this.isUserAllowedToUseCron()) {
        types.push('custom');
      }
      return [...new Set(types)];
    },
    filteredScheduleTypesForNonCronUsers() {
      const types = [...new Set(this.availableScheduleTypes)];
      if (this.$moonpull.currentUserHasAccessTo('monthlyScheduling')) {
        types.push('monthly');
      }
      return types.filter(type => type !== 'custom'); // Explicitly exclude "custom"
    },
  },

  methods: {
    dateFormat,

    toggleShowEditor() {
      this.showEditor = ! this.showEditor
    },

    toggleMoreOptions() {
      this.showMoreOptions = ! this.showMoreOptions
    },

    changeEditorTab(tab: EditorTab) {
      this.currentTab = tab
    },

    addLink() {
      this.batch.batchLinks.push({ ...this.defaultNewLink })
    },

    onSaveLink() {
      this.unsavedChanges = true
    },

    isUserAllowedToUseCron() {
      if( this.$moonpull.currentUserIsSuperAdmin() || [
        'thomas.bilz@awin.com',
        'lorena.brazil+awin@moonpullpartners.com', 
        'steven.brown+awin@moonpullpartners.com', 
        'lorena.brazil+ascend@moonpullpartners.com',
        'steven.brown+ascend@moonpullpartners.com',
        'ollie.pennington+awin_test@moonpullpartners.com',
      ].includes(this.$moonpull.getCurrentUserSession().email.toLowerCase()) ) {
        return true
      }
    },

    async onDeleteLink(linkToDelete: BatchLink) {
      const linkToDeleteIndex = this.batch.batchLinks.findIndex(link => link.order === linkToDelete.order)
      this.batch.batchLinks.splice(linkToDeleteIndex, 1)
      this.unsavedChanges = true
      this.saving = true
      await this.$apollo.mutate({
        mutation: gql`mutation BatchLinkDeleteById($id: ID!) {
          batchLinkDeleteById(id: $id)
        }`,
        variables: {
          id: linkToDelete.id
        }
      })
      this.saving = false
    },

    onChangeSchedule() {
      this.unsavedChanges = true;

      if (this.batch.scheduleType === 'monthly') {
        if (this.batch.scheduleDay < 1 || this.batch.scheduleDay > 28) {
          this.$store.dispatch('flashMessage', { type: 'warning', msg: 'Please enter a valid day of the month (1-28).' });
          this.batch.scheduleDay = null;
          return;
        }

        // Generate CRON expression for monthly schedule
        const day = this.batch.scheduleDay;
        const time = this.batch.scheduleTime || '00:00'; // Default to midnight if no time is set
        const [hour, minute] = time.split(':');
        this.batch.scheduleCron = `${minute} ${hour} ${day} * *`;
      }

      // Handle other schedule types (e.g., weekly)
    },

    onQueueChange() {
      this.unsavedChanges = true
    },

    async runNow() {
      if (! this.batch.batchLinks || this.batch.batchLinks.length === 0) {
        this.$store.dispatch('flashMessage', { type: 'warning', msg: 'Batches must have at least one link to run' })
        return
      }
      this.saving = true
      this.showMoreOptions = false
      const runBatchRes = await this.$apollo.mutate({
        mutation: gql`mutation RunBatch($batchId: ID!) {
          runBatch(batchId: $batchId)
        }`,
        variables: {
          batchId: this.batch.id,
        },
      })
      const runNowLink = this.$router.resolve({
        name: 'reporting-memory-cookie',
        params: { batchId: runBatchRes.data.runBatch }
      }).href
      this.runNowLink = runNowLink
      this.saving = false
      try {
        window.open(runNowLink, '_blank')
      } catch (e) {}
    },

    async saveBatch() {

      if (this.batch.batchLinks.length === 0) {
        this.$store.dispatch('flashMessage', { type: 'warning', msg: 'Batches must have at least one link' })
        return
      }

      this.saving = true

      // Assign order to links
      this.batch.batchLinks.forEach((link, i) => link.order = i)

      // Validation
      const user = this.$moonpull.getCurrentUserSession()

      const upsertBatchRecord = {
        name: this.batch.name,
        description: this.batch.description,
        isTemplate: true,
        scheduleType: this.batch.scheduleType,
        scheduleDay: this.batch.scheduleDay,
        scheduleTime: this.batch.scheduleTime,
        scheduleCron: this.batch.scheduleCron,
        ownerId: this.newBatchOwnerId || user.id,
        queueLetter: this.batch.queueLetter,
        useForLinkAssurance: this.batch.useForLinkAssurance,
        notifyOnComplete: this.batch.notifyOnComplete,
        scheduledRunningPaused: false, // Ensure scheduling is resumed
      }

      const upsertBatchLinksRecords = this.batch.batchLinks.map(l => ({
        ...l,
        editing: undefined,
        advancedOptionsVisible: undefined,
      }))

      // Update existing or create new
      if (this.batch.id) {

        // Assign Batch ID to all links
        upsertBatchLinksRecords.forEach(bl => bl.batchId = this.batch.id)

        // Upsert all links
        await this.$apollo.mutate({
          mutation: gql`mutation BatchLinkUpsertMany($batchLinks: [BatchLinkUpdateInput!]!) {
            batchLinkUpsertMany(records: $batchLinks) {
              id
              batchId
              link
              order
              userDefinedNetwork
              userDefinedMerchant
              placement
              name
              tagA
              tagB
              tagC
              tagD
              tagE
              countryCode
              proxyYN
              proxyCountryCode
              cookieType
              cookieName
              cookieValue
              extraTimeout
            }
          }`,
          variables: {
            batchLinks: upsertBatchLinksRecords,
          }
        })

        // Update and get batch
        const updateBatchRes = await this.$apollo.mutate({
          mutation: gql`mutation BatchUpdateById($batchId: ID!, $updatedBatch: BatchUpdateInput!) {
            batchUpdateById(
              id: $batchId
              record: $updatedBatch
            ) {
              id
              name
              description
              batchLinks {
                id
                batchId
                link
                order
                userDefinedNetwork
                userDefinedMerchant
                placement
                name
                tagA
                tagB
                tagC
                tagD
                tagE
                countryCode
                proxyYN
                proxyCountryCode
                cookieType
                cookieName
                cookieValue
                extraTimeout
              }
              startedAt
              csv
              isTemplate
              queueLetter
              owner {
                email
                name
                company {
                  name
                }
              }
              scheduleType
              scheduleDay
              scheduleTime
              scheduleCron
              schedulingError
              nextScheduledRunAt
              lastRunBatch {
                id
                startedAt
              }
              useForLinkAssurance
              notifyOnComplete
            }
          }`,
          variables: {
            batchId: this.batchId || this.batch.id,
            updatedBatch: upsertBatchRecord,
            owner: this.newBatchOwnerId || user.id,
          }
        })
        this.batch = updateBatchRes.data?.batchUpdateById
      }
      else {

        // Create new batch to get UUID
        const newBatchRes = await this.$apollo.mutate({
          mutation: gql`mutation BatchCreateOne($newBatch: CreateOneBatchInput!) {
            batchCreateOne(
              record: $newBatch
            ) {
              id
              name
              description
              startedAt
              csv
              isTemplate
              queueLetter
              owner {
                email
                name
                company {
                  name
                }
              }
              scheduleType
              scheduleDay
              scheduleTime
              scheduleCron
              schedulingError
              nextScheduledRunAt
              lastRunBatch {
                id
                startedAt
              }
              useForLinkAssurance
              notifyOnComplete
            }
          }`,
          variables: {
            newBatch: upsertBatchRecord,
          }
        })

        // Assign new UUID to batch links and upsert them
        const newBatchId = newBatchRes.data?.batchCreateOne?.id
        upsertBatchLinksRecords.forEach(link => link.batchId = newBatchId)
        const newLinksRes = await this.$apollo.mutate({
          mutation: gql`mutation BatchLinkUpsertMany($batchLinks: [BatchLinkUpdateInput!]!) {
            batchLinkUpsertMany(records: $batchLinks) {
              id
              batchId
              link
              order
              userDefinedNetwork
              userDefinedMerchant
              placement
              name
              tagA
              tagB
              tagC
              tagD
              tagE
              countryCode
              proxyYN
              proxyCountryCode
              cookieType
              cookieName
              cookieValue
              extraTimeout
            }
          }`,
          variables: {
            batchLinks: upsertBatchLinksRecords,
          }
        })

        this.batch = {
          ...newBatchRes.data?.batchCreateOne?.record,
          batchLinks: newLinksRes.data.batchLinkUpsertMany,
        }
      }
      this.unsavedChanges = false
      this.saving = false
      this.isBatchBroken = false
      this.$emit('save')
    },

    async downloadInputCsv() {
      this.saving = true
      const { data: { batchLinkCsv } } = await this.$apollo.query({
        query: gql`
          query ($batchId: ID!) {
            batchLinkCsv(batchId: $batchId)
          }
        `,
        variables: {
          batchId: this.batch.id,
        }
      })
      this.$moonpull.downloadCsv(batchLinkCsv, `${this.batch.id}_input.csv`)
      this.saving = false
    },

    async deleteBatch() {
      if (confirm(`This action is irreversible. This template batch will be deleted permanently and all future schedulings of this batch will be cancelled. Existing batches run from this template WILL NOT be affected. Are you sure?`)) {
        this.saving = true
        await this.$apollo.mutate({
          mutation: gql`mutation SoftDeleteBatchById($batchId: ID!) {
            batchSoftDeleteById(id: $batchId) {
              id
            }
          }`,
          variables: {
            batchId: this.batch.id
          }
        })
        this.$emit('delete')
      }
    },

    async togglePause() {
      if (! this.saving) {
        this.saving = true
        this.showMoreOptions = false
        const res = await this.$apollo.mutate({
          mutation: gql`mutation BatchTogglePause($batchId: ID!, $updatedBatch: BatchUpdateInput!) {
            batchUpdateById(
              id: $batchId
              record: $updatedBatch
            ) {
              scheduledRunningPaused
            }
          }`,
          variables: {
            batchId: this.batch.id,
            updatedBatch: {
              scheduledRunningPaused: ! this.batch.scheduledRunningPaused,
            }
          },
        })
        this.batch.scheduledRunningPaused = res.data?.batchUpdateById?.scheduledRunningPaused
        this.saving = false
      }
    },

    onDoneEditOwner() {
      this.unsavedChanges = true
      this.editingOwner = false
    },

    onChangeLinkAssurance() {
      this.unsavedChanges = true
    },

  },

  async beforeMount() {
    if (this.batchId) {
      const { data: { batchById } } = await this.$apollo.query({
        query: gql`query Batch($batchId: ID!) {
          batchById(id: $batchId) {
            id
            name
            description
            batchLinks {
              id
              batchId
              link
              order
              userDefinedNetwork
              userDefinedMerchant
              placement
              name
              tagA
              tagB
              tagC
              tagD
              tagE
              countryCode
              proxyYN
              proxyCountryCode
              cookieType
              cookieName
              cookieValue
              extraTimeout
            }
            startedAt
            csv
            isTemplate
            queueLetter
            owner {
              email
              name
              company {
                name
              }
            }
            scheduleType
            scheduleDay
            scheduleTime
            scheduleCron
            nextScheduledRunAt
            lastRunBatch {
              id
              startedAt
            }
            scheduledRunningPaused
            schedulingError {
              ts
              message
            }
            useForLinkAssurance
          }
        }`,
        variables: {
          batchId: this.batchId,
        }
      })
      this.batch = batchById
    }
    else if (this.preloadedBatch) {
      this.batch = this.preloadedBatch
    }

    if (! this.batch.scheduleType || (this.batch.scheduleType === 'weekly' && (! this.batch.scheduleDay || ! this.batch.scheduleTime))) {
      this.batch.scheduleType = null
      this.batch.scheduleDay = null
      this.batch.scheduleTime = null
    }

    // Mark batch as broken if any of the links don't have the "order"
    for (let i = 0; i < this.batch.batchLinks.length; i++) {
      const link = this.batch.batchLinks[i]
      if (link.order === undefined || link.order === null) {
        this.isBatchBroken = true
        this.unsavedChanges = true
        break
      }
    }
  },
  
})
